var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgVLocalServices = function (_a) {
    var title = _a.title, titleId = _a.titleId, desc = _a.desc, descId = _a.descId, props = __rest(_a, ["title", "titleId", "desc", "descId"]);
    return (_jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId }, props, { children: [desc ? _jsx("desc", __assign({ id: descId }, { children: desc })) : null, title ? _jsx("title", __assign({ id: titleId }, { children: title })) : null, _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 5a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-2 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z", fill: "currentColor" }), _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.312 23.726 12 23l-.688.726a1 1 0 0 0 1.376 0L12 23l.688.726v-.001l.002-.002.006-.005.02-.019a12.88 12.88 0 0 0 .337-.332 41.331 41.331 0 0 0 3.75-4.365C18.817 16.286 21 12.558 21 9A9 9 0 1 0 3 9c0 3.558 2.183 7.286 4.197 10.002a41.337 41.337 0 0 0 3.75 4.365 23.969 23.969 0 0 0 .337.332l.02.019.005.005.003.003ZM5 9a7 7 0 0 1 14 0c0 2.86-1.817 6.132-3.803 8.811A39.314 39.314 0 0 1 12 21.583a39.314 39.314 0 0 1-3.197-3.772C6.817 15.132 5 11.861 5 9Z", fill: "currentColor" })] })));
};
export default SvgVLocalServices;
